import React from "react"
import { Pressable, Text } from "react-native"

import TextStyle from "../../../TextStyle"
import Colors from "../../constants/AppColors"
import { CommonIconCTA } from "../CommonCTA"

export function CancelOrder(props) {
    const cancelOrder = props.cancelOrder
    return <Pressable onPress={() => { cancelOrder() }}
        style={{
            borderRadius: 20, borderColor: Colors.red.highlight,
            borderWidth: 1, paddingHorizontal: 12, paddingVertical: 6
        }}><Text style={[TextStyle.text14xb, {
            color: Colors.red.highlight
        }]}>Cancel Order</Text>
    </Pressable>
}

export function RateOrder(props) {
    const action = props.action
    return <CommonIconCTA title={'Rate'} icon={'rate_blue.svg'}
        borderWidth={2} borderRadius={20}
        paddingVertical={6} paddingHorizontal={12}
        iconWidth={16.3} iconHeight={15.6} imageTextGap={8}
        action={() => action()} />
}